<!-- =========================================================================================
  File Name: ResourceCreate.vue
  Description: Resource Create Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div v-if="optimizerManagerCreatePermission" id="page-user-edit">
		<vx-card>
			<optimizer-manager-tab-account class="mt-4" :data="{}" />
		</vx-card>
	</div>
	<not-permission v-else></not-permission>
</template>

<script>
import NotPermission from "@/views/pages/NotPermission.vue";
import OptimizerManagerTabAccount from "./OptimizerManagerTabAccount.vue";

export default {
	components: {
		NotPermission,
		OptimizerManagerTabAccount,
	},
	computed: {
		optimizerManagerCreatePermission() {
			return this.$store.getters.checkPermission("OPTIMIZER_MANAGER_C");
		},
	},
};
</script>

<style lang="scss" scoped>
#page-user-edit {
	height: 30%;
}
</style>
